'use client';
import { ComponentType } from 'react';
import { Props as GiftCardBalanceCheckProps } from './gift-card-balance-check.component';
import { PlaceholderConfig } from '@spa/lib/react/context/PlaceholderContext';
import dynamic from 'next/dynamic';

const DynamicGiftCardBalanceCheckComponent: ComponentType<GiftCardBalanceCheckProps> = dynamic(
  () => import('./gift-card-balance-check.component')
);

export default DynamicGiftCardBalanceCheckComponent;

export function calculateGiftCardBalanceCheckPlaceholderConfig(): PlaceholderConfig {
  const heightSinceWidth = [
    { sinceWidth: 0, height: 260 },
    { sinceWidth: 768, height: 280 },
    { sinceWidth: 1024, height: 360 }
  ];

  return {
    heightSinceWidth
  };
}
